import { useCallback } from 'react'
import { useQuery } from '@apollo/client'
import { HistoryInput } from '__generatedTypes__/globalTypes'
import { findMyUser } from '__generatedTypes__/findMyUser'
import { FIND_MY_USER } from 'queries/common'

export const useHistory = () => {
  const { data, loading } = useQuery<findMyUser>(FIND_MY_USER)
  const user = data?.findMyUser ?? null
  const username = `${user?.firstName} ${user?.lastName}`

  const populateHistoryWithUser = useCallback(
    (history?: HistoryInput[] | null) => [
      ...(history ?? []).map(({ updatedAt, updatedBy }) => ({ updatedAt, updatedBy })),
      {
        updatedBy: username,
        updatedAt: new Date().toISOString(),
      },
    ],
    [username]
  )

  return {
    loadingHistory: loading,
    populateHistoryWithUser,
  }
}
